import { render, staticRenderFns } from "./TenantFeatureItem.vue?vue&type=template&id=123db3f9&"
import script from "./TenantFeatureItem.vue?vue&type=script&lang=ts&"
export * from "./TenantFeatureItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports